import { render } from "./CompleteEditCompetiton.vue?vue&type=template&id=3df8edbd&scoped=true"
import script from "./CompleteEditCompetiton.vue?vue&type=script&lang=js"
export * from "./CompleteEditCompetiton.vue?vue&type=script&lang=js"

import "./CompleteEditCompetiton.vue?vue&type=style&index=0&id=3df8edbd&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df8edbd"]])

export default __exports__